import React, { memo, useMemo } from "react";

//styles
import { LogoWrapper, LOGO_WIDTH, LOGO_HEIGHT, Container, SlaTextWrapper } from "./styles";

//components
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { ElementVisibilitySensor } from "@swiggy-private/dls-web-core/dist/components/ElementVisibilitySensor";

//types
import { DeliverySlaCommsProps } from "./types";

//utils
import { isEmpty } from "@swiggy-private/js-utils";
import { replaceText } from "@swiggy-private/core-ui";

function SlaComms({ slaText, slaLogo, slaBgColor, onCommsVisible }: DeliverySlaCommsProps) {
    const message = useMemo(() => replaceText(slaText || "", "imageStyle"), [slaText]);

    if (isEmpty(slaText)) {
        return null;
    }

    return (
        <ElementVisibilitySensor onVisibilityChange={onCommsVisible} senseOnce={true}>
            <Container slaBgColor={slaBgColor}>
                <SlaTextWrapper color="text_High_Emphasis" variant="V2.overline.neutral.medium">
                    {message}
                </SlaTextWrapper>
                {!isEmpty(slaLogo) && (
                    <LogoWrapper aria-hidden="true">
                        <Image
                            cloudinaryId={slaLogo}
                            alt="sla-logo"
                            width={`${LOGO_WIDTH}px`}
                            height={`${LOGO_HEIGHT}px`}
                            cloudinaryHeight={LOGO_HEIGHT * 2}
                            cloudinaryWidth={LOGO_WIDTH * 2}
                        />
                    </LogoWrapper>
                )}
            </Container>
        </ElementVisibilitySensor>
    );
}

export default memo(SlaComms);
